// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"118":"f604f51d","361":"4802dbfb","465":"58f94bea"}[chunkId] + ".js";
};